import { S as Swiper } from './classes-to-selector-CbuwuCFr.js';
import { P as Pagination, N as Navigation } from './pagination-BPbOEUB3.js';

class ShopTheLook extends HTMLElement {
  swiperContainer = this.querySelector('.swiper');
  nextButton = this.querySelector('.swiper-button-next');
  prevButton = this.querySelector('.swiper-button-prev');
  pagination = this.querySelector('.swiper-pagination');

  connectedCallback() {
    if (!this.swiperContainer) return;

    this.initSwiper();
  }

  initSwiper() {
    this.swiperInstance = new Swiper(this.swiperContainer, {
      modules: [Pagination, Navigation],
      slidesPerView: 2,
      spaceBetween: 16,
      pagination: {
        el: this.pagination,
        clickable: true,
      },
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
    });
  }
}

customElements.define('shop-the-look', ShopTheLook);
